/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

const SERPListItemShape = PropTypes.shape({
  '@type': PropTypes.string,
  position: PropTypes.number,
  item: PropTypes.shape({
    '@type': PropTypes.string,
    url: PropTypes.string,
  }),
});

export default SERPListItemShape;
